import React from "react";
import { Link } from "react-router-dom";

import { Collection as CollectionType } from "../types/Collection";

import "../css/cover.css";

type Props = {
  collection: CollectionType;
};

const Collection = (props: Props) => {
  const { collection } = props;

  return (
    <Link
      to={`/collection/${collection.uid}`}
      className="nbk-collection"
      aria-label={collection.name ? `Voir la collection ${collection.name}` : "Voir la collection"}
    >
      <img
        src={`https://newbrand.s3.eu-west-3.amazonaws.com/collections/${collection.uid}/${collection.imgCollection}`}
        alt={collection.name || ""}
        loading="lazy"
        draggable={false}
      />
    </Link>
  );
};

export default Collection;
